import { motion } from 'framer-motion';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import ImpactSummaryBanner from './ImpactSummaryBanner';
import KPICards from './KPICards';
import GroupPerformancePanel from './GroupPerformancePanel';
import UserManagementTab from './UserManagementTab';
import GroupManagementTab from './GroupManagementTab';
import PaperOverviewTab from './PaperOverviewTab';
import ActivityLogTab from './ActivityLogTab';
import { INSTITUTION_CONFIG } from './mockData';

const InstitutionalDashboardContent = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 md:px-6 py-8 space-y-6">
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
      >
        <p className="text-sm font-medium uppercase tracking-widest text-primary mb-1">
          {INSTITUTION_CONFIG.name}
        </p>
        <h1 className="text-3xl md:text-4xl font-bold text-foreground">
          Institutional Dashboard
        </h1>
        <p className="text-muted-foreground mt-1">
          Institutsübergreifende Paper-Qualität im Überblick
        </p>
      </motion.div>

      {/* Impact Summary */}
      <ImpactSummaryBanner />

      {/* KPI Cards */}
      <KPICards />

      {/* Group Performance – full width */}
      <GroupPerformancePanel />

      {/* Tabs */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.5 }}
      >
        <Tabs defaultValue="users" className="w-full">
          <TabsList className="w-full justify-start bg-card/80 backdrop-blur-xl border border-border/50 rounded-xl p-1">
            <TabsTrigger value="users">Nutzer verwalten</TabsTrigger>
            <TabsTrigger value="groups">Gruppen</TabsTrigger>
            <TabsTrigger value="papers">Paper-Übersicht</TabsTrigger>
            <TabsTrigger value="activity">Aktivitätslog</TabsTrigger>
          </TabsList>

          <div className="mt-4 rounded-2xl border border-border/50 bg-card/80 backdrop-blur-xl p-6 shadow-lg">
            <TabsContent value="users" className="mt-0">
              <UserManagementTab />
            </TabsContent>
            <TabsContent value="groups" className="mt-0">
              <GroupManagementTab />
            </TabsContent>
            <TabsContent value="papers" className="mt-0">
              <PaperOverviewTab />
            </TabsContent>
            <TabsContent value="activity" className="mt-0">
              <ActivityLogTab />
            </TabsContent>
          </div>
        </Tabs>
      </motion.div>
    </div>
  );
};

export default InstitutionalDashboardContent;
